import { render, staticRenderFns } from "./UsersCatalog.vue?vue&type=template&id=2e023ee2&"
import script from "./UsersCatalog.vue?vue&type=script&lang=js&"
export * from "./UsersCatalog.vue?vue&type=script&lang=js&"
import style0 from "./UsersCatalog.vue?vue&type=style&index=0&id=2e023ee2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports